import { ref } from 'vue';
import _ from 'lodash';

export const useDirectLinkCopy = () => {
  const flashMessage = ref('');
  const flashIsError = ref(false);
  const flashKey = ref(0);

  const translate = (key, fallback = null) =>
    _.get(window.i18n, key) || fallback || key;

  const showFlash = (text, isError = false) => {
    flashMessage.value = text;
    flashIsError.value = isError;
    flashKey.value += 1;
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      showFlash(translate('video.direct_link_copy_success', 'リンクをコピーしました'), false);
    } catch (error) {
      showFlash(translate('video.direct_link_copy_failed', 'コピーに失敗しました'), true);
    }
  };

  const isValidId = (value) => value !== null && value !== undefined && value !== '';

  const buildDirectLinkUrl = ({ folderId, focusId = null }) => {
    // folder_idはTOP階層(folderIdなし)でも空文字で必ず付与する。
    // サーバー側はhas('folder_id')で絞り込み条件の有無を判定しており、省くとfocus_idが失われるため。
    const params = new URLSearchParams();
    params.set('folder_id', isValidId(folderId) ? String(folderId) : '');
    if (isValidId(focusId)) {
      params.set('focus_id', String(focusId));
    }
    return `${window.location.origin}/dashboard?${params.toString()}`;
  };

  const copyFileLink = async (selectedItem) => {
    if (!isValidId(selectedItem?.id)) {
      showFlash(translate('video.direct_link_copy_failed', 'コピーに失敗しました'), true);
      return;
    }
    await copyToClipboard(buildDirectLinkUrl({
      folderId: selectedItem?.folder_id,
      focusId: selectedItem?.id,
    }));
  };

  const copyFolderLink = async (folderId) => {
    if (!isValidId(folderId)) {
      showFlash(translate('video.direct_link_copy_failed', 'コピーに失敗しました'), true);
      return;
    }
    await copyToClipboard(buildDirectLinkUrl({ folderId }));
  };

  return {
    flashMessage,
    flashIsError,
    flashKey,
    copyFileLink,
    copyFolderLink,
  };
};
